import api from '../client'

export const analyticsApi = {
  getCreatorLeaderboard: async (orgSlug, params = {}) => {
    const response = await api.get(`/${orgSlug}/analytics/attribution`, { params })
    return response.data
  },
  getCreatorDetail: async (orgSlug, creatorId) => {
    const response = await api.get(`/${orgSlug}/analytics/attribution/${creatorId}`)
    return response.data
  },
  getCopyEvents: async (orgSlug, params = {}) => {
    const response = await api.get(`/${orgSlug}/analytics/copy-events`, { params })
    return response.data
  },
  getOutcomeTrends: async (orgSlug, params = {}) => {
    const response = await api.get(`/${orgSlug}/analytics/outcome-trends`, { params })
    return response.data
  },
  getImpressionStats: async (orgSlug, params = {}) => {
    const response = await api.get(`/${orgSlug}/analytics/impressions`, { params })
    return response.data
  },
  getTopPosts: async (orgSlug, params = {}) => {
    const response = await api.get(`/${orgSlug}/analytics/impressions/top-posts`, { params })
    return response.data
  },
  getTopCreators: async (orgSlug, params = {}) => {
    const response = await api.get(`/${orgSlug}/analytics/impressions/top-creators`, { params })
    return response.data
  },
  getBreakdown: async (orgSlug, params = {}) => {
    const response = await api.get(`/${orgSlug}/analytics/impressions/breakdown`, { params })
    return response.data
  },
  getScrollDepth: async (orgSlug, params = {}) => {
    const response = await api.get(`/${orgSlug}/analytics/impressions/scroll-depth`, { params })
    return response.data
  },
  getStates: async (orgSlug) => {
    const response = await api.get(`/${orgSlug}/analytics/states`)
    return response.data
  },
  downloadCreatorLeaderboard: async (orgSlug, params = {}) => {
    const response = await api.get(`/${orgSlug}/analytics/attribution/export`, {
      params,
      responseType: 'blob',
    })
    return response.data
  },
  downloadCopyEvents: async (orgSlug, params = {}) => {
    const response = await api.get(`/${orgSlug}/analytics/copy-events/export`, {
      params,
      responseType: 'blob',
    })
    return response.data
  },
  downloadOutcomeTrends: async (orgSlug, params = {}) => {
    const response = await api.get(`/${orgSlug}/analytics/outcome-trends/export`, {
      params,
      responseType: 'blob',
    })
    return response.data
  },
  downloadImpressionDaily: async (orgSlug, params = {}) => {
    const response = await api.get(`/${orgSlug}/analytics/impressions/daily/export`, {
      params,
      responseType: 'blob',
    })
    return response.data
  },
  downloadImpressionTopPosts: async (orgSlug, params = {}) => {
    const response = await api.get(`/${orgSlug}/analytics/impressions/top-posts/export`, {
      params,
      responseType: 'blob',
    })
    return response.data
  },
  listActions: async (orgSlug) => {
    const response = await api.get(`/${orgSlug}/analytics/actions`)
    return response.data
  },
  createAction: async (orgSlug, data) => {
    const response = await api.post(`/${orgSlug}/analytics/actions`, data)
    return response.data
  },
  deleteAction: async (orgSlug, id) => {
    const response = await api.delete(`/${orgSlug}/analytics/actions/${id}`)
    return response.data
  },
  listEvents: async (orgSlug) => {
    const response = await api.get(`/${orgSlug}/analytics/events`)
    return response.data
  },
  createEvent: async (orgSlug, data) => {
    const response = await api.post(`/${orgSlug}/analytics/events`, data)
    return response.data
  },
  deleteEvent: async (orgSlug, id) => {
    const response = await api.delete(`/${orgSlug}/analytics/events/${id}`)
    return response.data
  },
  listPresets: async (orgSlug) => {
    const response = await api.get(`/${orgSlug}/analytics/presets`)
    return response.data
  },
  createPreset: async (orgSlug, data) => {
    const response = await api.post(`/${orgSlug}/analytics/presets`, data)
    return response.data
  },
  deletePreset: async (orgSlug, id) => {
    const response = await api.delete(`/${orgSlug}/analytics/presets/${id}`)
    return response.data
  },
  getTimeline: async (orgSlug) => {
    const response = await api.get(`/${orgSlug}/analytics/timeline`)
    return response.data
  },
  listRecommendations: async (orgSlug) => {
    const response = await api.get(`/${orgSlug}/analytics/recommendations`)
    return response.data
  },
  getInsights: async (orgSlug) => {
    const response = await api.get(`/${orgSlug}/analytics/insights`)
    return response.data
  },
}

export const experimentApi = {
  list: async (orgSlug) => {
    const response = await api.get(`/${orgSlug}/experiments`)
    return response.data
  },
  create: async (orgSlug, data) => {
    const response = await api.post(`/${orgSlug}/experiments`, data)
    return response.data
  },
  get: async (orgSlug, id) => {
    const response = await api.get(`/${orgSlug}/experiments/${id}`)
    return response.data
  },
  update: async (orgSlug, id, data) => {
    const response = await api.patch(`/${orgSlug}/experiments/${id}`, data)
    return response.data
  },
  start: async (orgSlug, id) => {
    const response = await api.post(`/${orgSlug}/experiments/${id}/start`)
    return response.data
  },
  complete: async (orgSlug, id) => {
    const response = await api.post(`/${orgSlug}/experiments/${id}/complete`)
    return response.data
  },
  cancel: async (orgSlug, id) => {
    const response = await api.post(`/${orgSlug}/experiments/${id}/cancel`)
    return response.data
  },
}
